import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useFilter from '../hooks/useFilter';
import { getFieldAllList } from 'Api/endpoints/User';
import { useError } from 'Api/hooks/useError';
import icArrow1 from 'Assets/img/sidebar/ic_arrow_222_20.png';
import icArrow2 from 'Assets/img/sidebar/ic_arrow_222_20@2x.png';
import icArrow3 from 'Assets/img/sidebar/ic_arrow_222_20@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import YearDropdown from './YearDropdown';
import SearchInput from './SearchInput';
import SelectFieldItem from './SelectFieldItem';
import { useIntl } from 'react-intl';
import { usePopup } from 'Util/usePopup';
import { setLoading } from 'Actions/LoadingActions';
import { patchFieldActive } from 'Api/endpoints/User';
import { setAllFieldList, setDefaultField } from 'Actions/ConfigActions';
import toast from 'react-hot-toast';
import { isVietnam } from 'Util/DataUtils';

const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);

const StorageSection = ({ goToBasic, goToEdit }) => {
  const { user } = useSelector(state => state.authUser);
  const { allFieldList, defaultField } = useSelector(state => state.config);
  const { showErrorPopup } = useError();
  const { formatMessage } = useIntl();
  const [allStorageFieldList, setAllStorageFieldList] = useState([]);
  const [selectedFieldList, setSelectedFieldList] = useState([]);
  const { searchText, updateText, getFilteredList, yearList, selectedYear, updateYear } = useFilter({ fieldList: allStorageFieldList });
  const { showDialog } = usePopup();
  const dispatch = useDispatch();
  const fetchFieldList = useCallback(async () => {
    try {
      const response = await getFieldAllList({ page: 1, active: false });
      if (response.err) {
        showErrorPopup({ text: response.err.response.data.message });
        return;
      }
      if (response.data) {
        setAllStorageFieldList(response.data.items);
      }
    } catch (e) {
      console.log(e);
    }
  }, [showErrorPopup]);

  useEffect(() => {
    fetchFieldList();
  }, [fetchFieldList]);

  const toggleSelectedField = fieldId => {
    if (selectedFieldList.includes(fieldId)) {
      setSelectedFieldList(prev => prev.filter(id => id !== fieldId));
    } else {
      setSelectedFieldList(prev => [...prev, fieldId]);
    }
  };

  const renderCustomToast = () => {
    return (
      <div className="sidebar-field-edit-toast-message">
        <IntlMessages id="sidebar.field.edit.storage.restore.success" />
      </div>
    );
  };

  const restoreField = async () => {
    try {
      dispatch(setLoading(true));
      const result = await patchFieldActive({
        active: true,
        fieldIds: selectedFieldList,
      });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }

      let restoredFieldList = [...allStorageFieldList.filter(field => selectedFieldList.includes(field._id)), ...allFieldList];

      if (defaultField.isFirstField === true) {
        restoredFieldList = restoredFieldList.filter(field => field._id !== defaultField._id);
        if (restoredFieldList.length > 0) {
          dispatch(setDefaultField(restoredFieldList[0]));
        }
      }
      dispatch(setAllFieldList(restoredFieldList));
      toast.custom(renderCustomToast);
      setSelectedFieldList([]);
      goToBasic();
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleFieldRestore = () => {
    showDialog({
      title: 'sidebar.field.edit.storage.restore.title',
      content: 'sidebar.field.edit.storage.restore.sub',
      onConfirm: restoreField,
      confirmText: 'sidebar.field.edit.storage.restore',
      cancelText: 'common.no',
      confirmTextColor: '#0567F9',
    });
  };

  return (
    <>
      <div className="field-sidebar-fixed" data-field-toggle="true" style={{ gap: '20px' }}>
        <div className="field-sidebar-header">
          <div className="field-sidebar-header-edit-left cursor-pointer" onClick={goToEdit}>
            <img {...icArrow} alt="arrow" />
            <div className={`field-sidebar-header-edit-left-title ${isVietnam(user) && 'vi'}`}>
              <IntlMessages id="sidebar.field.edit.storage" />
            </div>
          </div>
          <div className="field-sidebar-header-edit-right">
            {selectedFieldList.length > 0 && (
              <span className="cursor-pointer no-drag" style={{ color: '#0567F9' }} onClick={handleFieldRestore}>
                <IntlMessages id="sidebar.field.edit.storage.restore" />
              </span>
            )}
          </div>
        </div>
        <div className="field-sidebar-filter-container">
          {yearList.length > 1 && <YearDropdown options={yearList} value={selectedYear} onChange={updateYear} />}
          <SearchInput text={searchText} onChangeText={e => updateText(e.target.value)} />
        </div>
      </div>
      <div className="field-sidebar-list">
        {searchText && getFilteredList.length === 0 ? (
          <div className="field-sidebar-list-empty">
            '<span className="field-sidebar-list-empty-highlight">{searchText}</span>'{formatMessage({ id: 'sidebar.field.empty.list' })}
          </div>
        ) : getFilteredList.length === 0 ? (
          <div className="field-sidebar-list-empty">
            <IntlMessages id="sidebar.field.edit.storage.empty" />
          </div>
        ) : (
          getFilteredList.map(field => {
            const isSelected = selectedFieldList.includes(field._id);
            return <SelectFieldItem key={field._id} field={field} isSelected={isSelected} onSelect={() => toggleSelectedField(field._id)} searchText={searchText} isStorage={true} />;
          })
        )}
      </div>
    </>
  );
};

export default StorageSection;
